<template>
    <v-select
        v-model="model"
        label="Monitor Install Type"
        :items="ALL_MONITOR_INSTALL_TYPES"
        @update:modelValue="syncVModel"
        :item-title="showDescriptions ? 'longTitle' : 'shortTitle'"
        item-value="value"
        :error-messages="errorMessages"
        @blur="$emit('blur')"
    ></v-select>
</template>

<script lang="ts" setup>
import type { MonitorInstallTypesV1 } from '@geckoal/gecko-api-client'
import { ref, watch, type PropType } from 'vue'
import { ALL_MONITOR_INSTALL_TYPES } from '../../lib/monitorInstallTypes'

const props = defineProps({
    modelValue: {
        type: String as PropType<MonitorInstallTypesV1>
    },
    showDescriptions: {
        type: Boolean
    },
    errorMessages: {
        type: Array as PropType<string[]>
    }
})

const model = ref<MonitorInstallTypesV1 | undefined>()

watch(
    () => props.modelValue,
    (value) => {
        model.value = value
    },
    { immediate: true }
)

const emit = defineEmits(['update:modelValue', 'blur'])

const syncVModel = () => {
    emit('update:modelValue', model.value)
}
</script>
